import React from 'react';

import '../../../css/components/contact/contact-field.scss';
export function ContactField(props) {
  const {
    name,
    fieldType,
    value,
    label,
    onChange,
  } = props;

  let input;
  switch (fieldType) {
    case 'textarea':
      input = <textarea name={ name} onChange={ onChange } value={ value } />
      break;
  
    case 'input':
    default:
      input = <input name={ name} onChange={ onChange } value={ value } />
      break;
  }

  return (
    <div className="contact-field">
      <label>
        { label }
      </label>
      { input }
    </div>
  )
}